import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_3M_66_65_3M_21_99_EN_CLUSTER',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_3m_66_65_3m_21_99_usd',
			GBP: 'simple_premium_3m_66_65_3m_24_99_gbp',
			CAD: 'simple_premium_3m_99_99_3m_27_99_cad',
			AUD: 'simple_premium_3m_99_99_3m_33_99_aud',
		},
		primer: 'prd_NHhvrPLOWt2k',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: {
		days: 90,
		priceMap: {
			USD: 21.99,
			GBP: 24.99,
			CAD: 27.99,
			AUD: 33.99,
		},
		originalPriceMap: {
			USD: 66.65,
			GBP: 66.65,
			CAD: 99.99,
			AUD: 99.99,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 66.65,
			GBP: 66.65,
			CAD: 99.99,
			AUD: 99.99,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('female_yoga.pages.paywall.plans.12_weeks.into_period_text'), // first three months
		explicitTermsIntervalText: $t('female_yoga.pages.paywall.plans.12_weeks.period_text'), // 3 months
		billingSubtitlePeriodText: $t('female_yoga.pages.paywall.plans.12_weeks.billing_period_text'), // 'three months'
		footerPeriodText: $t('female_yoga.pages.paywall.plans.12_weeks.footer_period_text'), // '3-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.90_days.sub_period_text'), // '3-month'
		updatedTermsPeriodText: $t('female_yoga.pages.paywall.plans.12_weeks.terms_period_text'), // 'first 3 months'
	}),
}
